import React from 'react'
import ReactDOM from 'react-dom'
import Loading from '@ublique/components/Loading'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { version } from '../package.json'

console.log(`version: ${version}`)

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<Loading />}>
      <App />
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
